var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.69 10.75c-1.89 0-3.43-1.54-3.43-3.43V4.69c0-1.89 1.54-3.43 3.43-3.43h14.63c1.89 0 3.43 1.54 3.43 3.43v2.63c0 1.89-1.54 3.43-3.43 3.43H4.69zM2.75 4.68v2.63c0 1.07.87 1.93 1.93 1.93h14.63c1.07 0 1.93-.87 1.93-1.93V4.68c0-1.07-.87-1.93-1.93-1.93H4.68c-1.07 0-1.93.87-1.93 1.93zM4.69 22.75c-1.89 0-3.43-1.54-3.43-3.43v-2.63c0-1.89 1.54-3.43 3.43-3.43h14.63c1.89 0 3.43 1.54 3.43 3.43v2.63c0 1.89-1.54 3.43-3.43 3.43H4.69zm-1.94-6.07v2.63c0 1.07.87 1.93 1.93 1.93h14.63c1.07 0 1.93-.87 1.93-1.93v-2.63c0-1.07-.87-1.93-1.93-1.93H4.68c-1.07 0-1.93.87-1.93 1.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7V5c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM9.25 7V5c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM5.25 19v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM9.25 19v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14 6.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM14 18.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDriver);
export default __webpack_public_path__ + "static/media/vuesax-outline-driver.c09e9676bdc477731182ce7c72d02296.svg";
export { ForwardRef as ReactComponent };